module.exports = __webpack_public_path__ + "static/npckc0-98a7bf2d8a6bd3989c3b2c3d05e5c51f.webp";